<template>
  <div>
    <vue-particles
      id="particles-js"
      class="login-background"
      color="#ffffff"
      :particleOpacity="0.7"
      linesColor="#ffffff"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="5"
      :linesWidth="2"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    />
    <div class="middle-boxbg text-center animated fadeInDown">
      <el-row style="margin-top: 30px;">
        <el-col :span="24">
          <div>
            <img class="icon" src="https://sqtech.oss-cn-beijing.aliyuncs.com/Logo.png"/>
          </div>
          <div style="margin-top: 20px;">
            <span style="font-size: 22px;">硕祺电商平台</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="divtop">
        <el-col :span="24">
          <el-form ref="form">
            <el-input placeholder="请输入用户名" v-model="username" style="width:300px; margin-bottom: 10px;">
              <template class="labeltemplate" slot="prepend">用户名</template>
            </el-input>
            <el-input placeholder="请输入密码" type="password" v-model="password" style="width:300px; margin-bottom: 20px;">
              <template class="labeltemplate" slot="prepend">密码</template>
            </el-input>
            <drag-verify :width="width"
                         :height="height"
                         :text="text"
                         :success-text="successText"
                         :background="background"
                         :progress-bar-bg="progressBarBg"
                         :completed-bg="completedBg"
                         :handler-bg="handlerBg"
                         :handler-icon="handlerIcon"
                         :text-size="textSize"
                         :success-icon="successIcon"
                         ref="Verify"></drag-verify>
            <button type="button" class="btn btncrn btn-primary block full-width m-b"  v-on:click="OnLogin">登 录 平 台</button>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import Utils from '../util/utils'
  import { Message } from 'element-ui'
  import dragVerify from 'vue-drag-verify'
  import VueParticles from 'vue-particles'
  Vue.use(VueParticles)
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'Login',
    components: { dragVerify },
    data () {
      return {
        username: '',
        password: '',
        handlerIcon: 'fa fa-angle-double-right',
        successIcon: 'fa fa-check',
        background: '#E0E1E2',
        progressBarBg: '#66cc66',
        completedBg: '#66cc66',
        handlerBg: '#fff',
        text: '请将滑块拖动到右侧',
        successText: '验证成功',
        width: 300,
        height: 42,
        textSize: '14px',
        isCircle: 'true'
      }
    },
    beforeCreate: function () {
      console.log('创建开始')
      console.log(this)
      that = this
    },
    methods: {
      checkusername () {
        if (!AntiSqlValid(that.username) || !AntiSqlValid(that.password)) {
          Message.error('恶意信息，请立即调整')
        } else {
          var qstr = {
            whereinfo: " username='" + that.username + "' and password='" + that.password + "'",
            limit: '',
            sortinfo: ''
          }
          if (that.username !== '' && that.password !== '' && that.$refs.Verify.isPassing) {
            that.$http({
              url: 'https://ecommapi.sqnetsoft.cn/login',
              method: 'post',
              data: qstr,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                window.console.log(res)
                window.console.log(res.data)
                if (res.data.length >= 1) {
                  window.console.log(res.data)
                  var tmpdata = res.data[0]
                  setCookieEx('username', that.username, 3600)
                  localStorage.setItem('models', tmpdata.modelName)
                  localStorage.setItem('phone', tmpdata.username)
                  localStorage.setItem('username', tmpdata.username)
                  localStorage.setItem('type', tmpdata.usergroups_id)
                  localStorage.setItem('cusid', tmpdata.cus_id)
                  setCookie('cusid',tmpdata.cus_id, 1)
                  localStorage.setItem('id', tmpdata.id)
                  localStorage.setItem('userimg', '')
                  localStorage.setItem('realname', tmpdata.realName)
                  localStorage.setItem('postid', tmpdata.post)
                  setCookie('SelectMainMenuID', '98', 1)
                  // that.writelog()
                  that.$router.push({path: 'Dashboard'})
                } else {
                  Message.error('用户名或密码错误')
                }
              })
              .catch(function (error) {
                Message.error('服务器无法登陆')
                console.log('error' + error)
              })
          } else {
            Message.error('请检查您的输入，并验证')
          }
        }
      },
      writelog () {
        let dateTime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
        window.console.log(dateTime)
        var adddata = {
          id: '',
          username: localStorage.getItem('realname'),
          realname: localStorage.getItem('realname'),
          optxt: '用户登录',
          ip: localStorage.getItem('Ip'),
          adddate: dateTime
        }
        window.console.log(adddata)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addli',
          method: 'post',
          data: adddata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      OnLogin: function () {
        console.log(this.$refs.Verify.isMoving)
        console.log(this.$refs.Verify.isPassing)
        if (this.username !== '' && this.password !== '' && this.$refs.Verify.isPassing) {
          that.checkusername()
        } else {
          Message.error('请检查您的输入，并验证')
        }
      }
    }
  }
  function AntiSqlValid(oField) {
    var re = /select|update|delete|exec|count|'|"|=|;|>|<|%/i;
    if (re.test(oField)) {
      return false;
    } else {
      return true
    }
  }
  function setCookie (name, value, days) {
    var d = new Date()
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
    window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
  }
  function setCookieEx (name, value, seconds) {
    var d = new Date()
    d.setTime(d.getTime() + 1000 *seconds)
    window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
  }

</script>

<style>
  el-input {
    margin-top: 10px;
  }
  .el-input-group__prepend {
    border-right: 0;
    width: 100px;
  }
  .weui-desktop-page__title {
    font-size: 24px;
    font-weight: 400;
    margin-top: 20px;
    line-height: 1;
    margin-bottom: 20px;
  }
  .icon {
    width: 120px;
    height: 120px;
  }
  .divtop
  {
    text-align: center;
    color: #2c3e50;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  h3
  {
    margin-top: 20px;
    font-size: 16px;
  }

  .loginscreen.middle-box {
    width: 300px;
  }
  .middle-box h1 {
    font-size: 170px;
  }
  .wrapper .middle-box {
    margin-top: 140px;
  }
  .middle-boxbg {
    border-radius: 10px;
    max-width: 450px;
    z-index: 100;
    margin-top: 160px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    box-shadow: 0px 0px 100px 10PX black;
    background:rgba(255,255,255,0.9);
  }
  .drag_verify {
    position: relative;
    display: inline-table;
    background-color: #e8e8e8;
    text-align: center;
  }
  .btncrn
  {
    width: 300px;
    border-radius:5px;
    margin-top: 60px;
    margin-bottom: 10px;
  }

  .loginscreen.middle-box {
    width: 300px;
  }
  .navbar-form-custom .form-control {
    background: none repeat scroll 0 0 rgba(0, 0, 0, 0);
    border: medium none;
    font-size: 14px;
    margin-top: 10px;
    z-index: 2000;
  }

  .navbar-form-custom .form-control:focus{
    border-bottom: 1px solid #f1f1f1;
  }
  .login-background {
    background-image: url("https://sqpro.oss-cn-beijing.aliyuncs.com/bg/sky.jpg");
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue